import React, { memo } from "react";
import { Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

const truncateCss = {
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

const addIconCss = {
  display: "inline-flex",
  verticalAlign: "middle",
};

const AddNoteOption = ({ inputValue }) => (
  <Box display="flex" sx={{ color: (theme) => theme.palette.primary.main }}>
    <div style={truncateCss}>
      <AddIcon size="small" style={addIconCss} />
      <span title={inputValue}>{`New Note: "${inputValue}"`}</span>
    </div>
  </Box>
);

export default memo(AddNoteOption);
